import { getInternalLinkTypeForFindStore } from "@/utils/helper"

export const locationIconDataAnalytics = res => {
  const { message = "n/a", LocationName } = res
  const internalLinkType = getInternalLinkTypeForFindStore(
    res.LocationName,
    res.Locality,
    res.StateLong
  )
  const eventInfo = {
    eventAction: "find a store:landing:map:location icon",
    eventName: "find a store:landing:map:location icon",
    eventType: "navigation",
    eventMsg: message?.toLowerCase(),
    eventStatus: "n/a",
    internalLinkName: LocationName?.toLowerCase(),
    internalLinkPosition: "find a store landing map​",
    internalLinkType: `find a store:${internalLinkType}`,
    internalLinkZoneName: "find a store:landing:map",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo: eventInfo,
    page: page,
  })
}
